import React from 'react';
import { FiArrowUp } from 'react-icons/fi';
import useThemeColors from '../../hooks/useThemeColors';

const PlatformMetricCard = ({ 
  title, 
  value, 
  growth, 
  icon: Icon, 
  platformColor = "pink",
  subtitle,
  className = ""
}) => {
  const { isDark } = useThemeColors();
  
  const colorClasses = {
    pink: {
      bgLight: "bg-pink-100",
      bgDark: "bg-pink-900/30",
      textLight: "text-pink-600",
      textDark: "text-pink-400",
      borderLight: "border-pink-200",
      borderDark: "border-pink-700"
    },
    purple: {
      bgLight: "bg-purple-100",
      bgDark: "bg-purple-900/30",
      textLight: "text-purple-600",
      textDark: "text-purple-400",
      borderLight: "border-purple-200",
      borderDark: "border-purple-700"
    },
    red: {
      bgLight: "bg-red-100",
      bgDark: "bg-red-900/30",
      textLight: "text-red-600",
      textDark: "text-red-400",
      borderLight: "border-red-200",
      borderDark: "border-red-700"
    },
    blue: {
      bgLight: "bg-blue-100",
      bgDark: "bg-blue-900/30",
      textLight: "text-blue-600",
      textDark: "text-blue-400",
      borderLight: "border-blue-200",
      borderDark: "border-blue-700"
    },
    green: {
      bgLight: "bg-green-100",
      bgDark: "bg-green-900/30",
      textLight: "text-green-600",
      textDark: "text-green-400",
      borderLight: "border-green-200",
      borderDark: "border-green-700"
    }
  };

  const colorScheme = colorClasses[platformColor] || colorClasses.pink;
  const bg = isDark ? colorScheme.bgDark : colorScheme.bgLight;
  const text = isDark ? colorScheme.textDark : colorScheme.textLight;

  return (
    <div className={`--theme-colors rounded-lg shadow-md ${className}`}>
      <div className="p-4 sm:p-6">
        <div className="flex items-center justify-between gap-2">
          <div className="min-w-0 flex-1">
            <p className={`text-xs sm:text-sm font-medium ${
              isDark ? 'text-gray-400' : 'text-gray-600'
            }`}>
              {title}
            </p>
            <p className="text-lg sm:text-2xl font-bold --theme-colors mt-1">
              {value}
            </p>
            {subtitle && (
              <p className={`text-xs sm:text-sm mt-1 ${
                isDark ? 'text-gray-500' : 'text-gray-500'
              }`}>
                {subtitle}
              </p>
            )}
            {growth && (
              <div className="flex items-center gap-1 mt-1">
                <FiArrowUp className={`w-3 h-3 sm:w-4 sm:h-4 ${
                  isDark ? 'text-green-400' : 'text-green-500'
                }`} />
                <span className={`text-xs sm:text-sm font-medium ${
                  isDark ? 'text-green-400' : 'text-green-600'
                }`}>
                  +{growth}%
                </span>
              </div>
            )}
          </div>
          {Icon && (
            <div className={`w-10 h-10 sm:w-12 sm:h-12 ${bg} rounded-full flex items-center justify-center flex-shrink-0`}>
              <Icon className={`w-5 h-5 sm:w-6 sm:h-6 ${text}`} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlatformMetricCard; 